import { api } from "@/api/client";

export interface HtmlArtifactSummary {
  id: string;
  title: string;
  project_id: string | null;
  artifact_type: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface HtmlArtifactDetail extends HtmlArtifactSummary {
  html_content: string;
  metadata: Record<string, unknown> | null;
  viewer_url: string;
  slug: string;
}

export interface HtmlArtifactListResponse {
  artifacts: HtmlArtifactSummary[];
  total: number;
}

export async function listArtifacts(params?: {
  project_id?: string;
  limit?: number;
  offset?: number;
}): Promise<HtmlArtifactListResponse> {
  const query = new URLSearchParams();
  if (params?.project_id) query.set("project_id", params.project_id);
  if (params?.limit !== undefined)
    query.set("limit", String(params.limit));
  if (params?.offset !== undefined)
    query.set("offset", String(params.offset));
  const qs = query.toString();
  return api<HtmlArtifactListResponse>(
    `/api/v1/artifacts/html${qs ? `?${qs}` : ""}`,
  );
}

export async function getArtifact(id: string): Promise<HtmlArtifactDetail> {
  return api<HtmlArtifactDetail>(
    `/api/v1/artifacts/html/${encodeURIComponent(id)}`,
  );
}

export interface HtmlArtifactVersionEntry {
  id: string;
  version: number;
  parent_artifact_id: string | null;
  created_at: string;
  revoked_at: string | null;
  viewer_url: string;
}

export interface HtmlArtifactVersionsResponse {
  slug: string;
  project_id: string | null;
  latest_version: number | null;
  versions: HtmlArtifactVersionEntry[];
}

export async function listArtifactVersions(
  id: string,
): Promise<HtmlArtifactVersionsResponse> {
  return api<HtmlArtifactVersionsResponse>(
    `/api/v1/artifacts/html/${encodeURIComponent(id)}/versions`,
  );
}
